import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import LoadModalWithLabel from "./LoadModalWithLabel"
import ItensModal from "./ItensModal"
import {
  Loading,
  InputCustom,
  SelectCustom,
  TextArea,
  InputCurrency,
  HttpError
} from "../../components"
import InputDinheiroBR from "../../components/InputDinheiroBR"
import Moment from "moment"
import Util from "../../Util"
import * as ApiHelper from "../../ApiHelper"
import * as constants from "../../constants"
import { ToastContainer, ToastMessage } from "react-toastr"
class AditivosForm extends Component {
  constructor() {
    super()
    this.fillFields = this.fillFields.bind(this)
    this.getEditFields = this.getEditFields.bind(this)
    this.getContratoOriginal = this.getContratoOriginal.bind(this)
    this.calculateFinalExecucao = this.calculateFinalExecucao.bind(this)
    this.onChangeInicioExecucao = this.onChangeInicioExecucao.bind(this)
    this.onChangeExecucao = this.onChangeExecucao.bind(this)
    this.onChangeEmExecucao = this.onChangeEmExecucao.bind(this)
    this.addItemRealinhamento = this.addItemRealinhamento.bind(this)
    this.removeItemRealinhamento = this.removeItemRealinhamento.bind(this)
    this.addItem = this.addItem.bind(this)
    this.removeItem = this.removeItem.bind(this)
    this.onChangeObjeto = this.onChangeObjeto.bind(this)
    this.onChangeGestor = this.onChangeGestor.bind(this)
    this.onChangeObservacao = this.onChangeObservacao.bind(this)
    this.onChangeDataAssinado = this.onChangeDataAssinado.bind(this)
    this.onChangeDataExtrato = this.onChangeDataExtrato.bind(this)
    this.onChangeLocalExtrato = this.onChangeLocalExtrato.bind(this)
    this.onChangeNumAditivo = this.onChangeNumAditivo.bind(this)
    this.onChangeFinalVigencia = this.onChangeFinalVigencia.bind(this)
    this.sendForm = this.sendForm.bind(this)
    this.reloadItem = this.reloadItem.bind(this)
    this.toggleItensModal = this.toggleItensModal.bind(this)
    this.toggleLoadModal = this.toggleLoadModal.bind(this)
    this.state = {
      contratoOriginal: {},
      objeto: "",
      inicioExecucao: "",
      observacao: "",
      dataAssinado: "",
      execucao: "",
      gestores: [],
      emExecucao: "",
      finalVigencia: "",
      finalExecucao: "",
      dataExtrato: "",
      localExtracao: "",
      contratoId: "",
      gestor: "",
      itensDeContrato: "",
      currentItens: [],
      showItemModal: false,
      showLoad: false,
      naQuantidade:false,//
      currentItensRealinhamento: [],
      itens: [],
      itensError: [],
      itensRealinhamento: [],
      itensRealinhamentoError: []
    }
    this.showSucessMessage = this.showSucessMessage.bind(this)
    this.toastFactory = React.createFactory(ToastMessage.animation)
  }
  toggleLoadModal() {
    this.setState({
      showLoad: !this.state.showLoad
    })
  }
  showSucessMessage() {
    var message = ""
    var title = "Sucesso"
    if (this.props.isEditing) {
      message = "Aditivo atualizado com sucesso"
    } else {
      message = "Aditivo cadastrado com sucesso"
    }
    this.container.success(title, message, {
      timeOut: 2000,
      extendedTimeOut: 3000
    })
  }
  showErrorMessage() {
    this.container.error(
      "Ocorreram erros",
      "Verifique os dados e tente novamente",
      {
        timeOut: 2000,
        extendedTimeOut: 3000
      }
    )
  }
  addAlert(title, message) {
    this.container.error(title, message, {
      timeOut: 5000,
      extendedTimeOut: 3000
    })
  }
  fillFields(fields) {
    var itensRealinhamento = []
    var itens = []
    fields.itens_de_contratos.forEach(item => {
      if (item.valor === 0 && parseFloat(item.quantidade) === 0) {
        item.realinhamento = true
        itensRealinhamento.push(item)
      } else {
        item.aditivo = true
        itens.push(item)
      }
    })
    var currentFields = {
      numAditivo: fields.num_contrato,
      objeto: fields.objeto,
      inicioExecucao: fields.inicio_execucao || "",
      dataAssinado: fields.data_assinado,
      execucao: fields.execucao || "",
      emExecucao: fields.em_execucao || "",
      finalVigencia: fields.final_vigencia.date,
      finalExecucao: fields.final_execucao,
      gestor: fields.gestor_id,
      dataExtrato: fields.data_publicacao_extrato,
      localExtracao: fields.local_extracao,
      contratoId: fields.contrato_original.id,
      observacao: fields.observacao,
      contratoOriginal: fields.contrato_original,
      currentItens: itens,
      currentItensRealinhamento: itensRealinhamento,
      showForm: true
    }
    this.setState(currentFields)
  }
  getEditFields() {
    ApiHelper.getAditivoEdit(this.props.match.params.id, (data, error) => {
      if (data) {
        var aditivo = data.aditivo
        var itensDeContrato = Util.mapItensDeContrato(data.itens)
        var gestores = Util.mapGestores(data.gestores)
        this.setState({
          gestores: gestores,
          itensDeContrato: itensDeContrato
        })
        this.fillFields(aditivo)
      } else {
        this.setState({
          httpError: error
        })
      }
    })
  }
  onChangeInicioExecucao(value) {
    var newValue = value
    this.setState(
      { inicio_execucaoError: "", inicioExecucao: newValue },
      () => {
        this.calculateFinalExecucao()
      }
    )
  }
  onChangeExecucao(event) {
    var newValue = event.target.value
    this.setState({ execucaoError: "", execucao: newValue }, () => {
      this.calculateFinalExecucao()
    })
  }
  onChangeEmExecucao(event) {
    var newValue = event.target.value
    this.setState({ em_execucaoError: "", emExecucao: newValue }, () => {
      this.calculateFinalExecucao()
    })
  }
  onChangeGestor(event) {
    var newValue = event.target.value
    this.setState({ gestor_idError: "", gestor: newValue })
  }
  calculateFinalExecucao() {
    if (
      this.state.inicioExecucao &&
      this.state.execucao &&
      this.state.emExecucao
    ) {
      var inicioExecucao = Moment(this.state.inicioExecucao)
      var finalExecucao = inicioExecucao
        .add(this.state.execucao, this.state.emExecucao)
        .format("YYYY-MM-DD")
      this.setState({ finalExecucao: finalExecucao })
    }
  }
  componentWillMount() {
    if (this.props.isEditing) {
      this.getEditFields()
    } else {
      this.getContratoOriginal()
    }
  }

  getContratoOriginal() {
    ApiHelper.getAditivoCreate(this.props.match.params.id, (data, error) => {
      if (data) {
        var date = new Date()
        var year = date.getFullYear()
        var month = (date.getMonth() + 1 + "").padStart(2, 0)
        var day = (date.getDate() + "").padStart(2, 0)
        var dateString = [year, month, day].join("-")
        console.log(dateString)
        this.setState({
          contratoOriginal: data.contrato,
          itensDeContrato: Util.mapItensDeContrato(data.itens),
          gestores: Util.mapGestores(data.gestores),
          gestor: data.contrato.gestor_id,
          dataAssinado: dateString,
          finalVigencia: data.contrato.final_vigencia.date,
          showForm: true
        })
      } else {
        this.setState({
          httpError: error
        })
      }
    })
  }
  addItem(event) {
    event.preventDefault()
    var oldItens = this.state.itens
    var oldItensError = this.state.itensError
    oldItensError.push({
      item_aditivo_id: "",
      quantidade: ""
    })
    oldItens.push({
      itemAditivoId: "",
      quantidade: "",
      valor: "",
      isReducao: false
    })
    this.setState({
      itens: oldItens
    })
  }
  removeItem(event) {
    event.preventDefault()
    var oldItens = this.state.itens
    var oldItensError = this.state.itensError
    oldItensError.pop()
    oldItens.pop()
    this.setState({
      itens: oldItens
    })
  }
  addItemRealinhamento() {
    var oldItens = this.state.itensRealinhamento
    var oldItensError = this.state.itensRealinhamentoError
    oldItensError.push({
      item_aditivo_id: "",
      valor_unitario: ""
    })
    oldItens.push({
      itemAditivoId: "",
      valor: ""
    })
    this.setState({
      itensRealinhamento: oldItens,
      itensRealinhamentoError: oldItensError
    })
  }
  removeItemRealinhamento() {
    var oldItens = this.state.itensRealinhamento
    var oldItensError = this.state.itensRealinhamentoError
    oldItensError.pop()
    oldItens.pop()
    this.setState({
      itensRealinhamento: oldItens,
      itensRealinhamentoError: oldItensError
    })
  }
  onChangeValorRealinhamento(event, index, value) {
    var oldItens = this.state.itensRealinhamento
    var oldItensError = this.state.itensRealinhamentoError
    oldItensError[index].valor_unitario = ""
    oldItens[index].valor = value
    this.setState({
      itensRealinhamento: oldItens,
      itensRealinhamentoError: oldItensError
    })
  }
  onChangeItemAditivoRealinhamento(event, index) {
    var newValue = event.target.value
    var oldItens = this.state.itensRealinhamento
    var oldItensError = this.state.itensRealinhamentoError
    oldItensError[index].item_aditivo_id = ""
    oldItens[index].itemAditivo = newValue
    this.setState({
      itensRealinhamento: oldItens,
      itensRealinhamentoError: oldItensError
    })
  }
  onChangeItemAditivo(event, index) {
    var newValue = event.target.value
    var oldItens = this.state.itens
    var oldItensError = this.state.itensError
    oldItensError[index].item_aditivo_id = ""
    oldItens[index].itemAditivo = newValue
    this.setState({
      itens: oldItens,
      itensError: oldItensError
    })
  }
  getValorUnitarioByID(id) {
    var item = this.state.itensDeContrato.filter(item => {
      return "" + item.value === id
    })[0]
    return item !== undefined ? item.valorTotal : 0
  }
  onChangeQuantidadeAditivo(event, index, value) {
    var oldItens = this.state.itens
    var oldItensError = this.state.itensError
    var isQuantidade = oldItens[index].isQuantidade
    if (isQuantidade) {
      oldItensError[index].quantidade = ""
      oldItens[index].quantidade = event.target.value
    } else {
      var valor = this.getValorUnitarioByID(oldItens[index].itemAditivo)
      oldItensError[index].quantidade = ""
      oldItens[index].quantidade = (value / valor) * 100
    }
    this.setState({
      itens: oldItens,
      itensError: oldItensError
    })
  }
  onChangeIsQuantidade(event, index) {
   this.setState({naQuantidade: event.target.checked})//
    var oldItens = this.state.itens
    oldItens[index].isQuantidade = event.target.checked
    this.setState({
      itens: oldItens
    })
  }
  onChangeIsReducao(event, index) {
    var oldItens = this.state.itens
    var oldItensError = this.state.itensError
    oldItensError[index].isReducao = ""
    oldItens[index].isReducao = event.target.checked
    this.setState({
      itens: oldItens,
      itensError: oldItensError
    })
  }
  onChangeNumAditivo(event) {
    var newValue = event.target.value
    this.setState({
      numAditivo: newValue,
      num_contratoError: ""
    })
  }
  onChangeDataAssinado(value) {
    this.setState({
      dataAssinado: value,
      data_assinadoError: ""
    })
  }
  onChangeLocalExtrato(event) {
    var newValue = event.target.value
    this.setState({
      localExtracao: newValue,
      local_extracaoError: ""
    })
  }
  onChangeDataExtrato(value) {
    this.setState({
      dataExtrato: value,
      data_publicacao_extratoError: ""
    })
  }
  onChangeObjeto(event) {
    var newValue = event.target.value
    this.setState({
      objeto: newValue,
      objetoError: ""
    })
  }
  onChangeObservacao(event) {
    var newValue = event.target.value
    this.setState({
      observacao: newValue
    })
  }
  onChangeFinalVigencia(value) {
    this.setState({
      finalVigencia: value,
      final_vigenciaError: ""
    })
  }
  sendForm(event) {
    event.preventDefault()
    var itens = []
    var itensRealinhamento = []
    this.state.itens.forEach(item => {
      itens.push({
        item_aditivo_id: item.itemAditivo,
        quantidade: item.quantidade,
        is_reducao: item.isReducao,
        naQuantidade:this.state.naQuantidade,//
      })
    })
    this.state.itensRealinhamento.forEach(item => {
      itensRealinhamento.push({
        item_aditivo_id: item.itemAditivo,
        valor_unitario: item.valor,
        is_reducao: 'false'//
      })
    })
    var params = {
      objeto: this.state.objeto,
      inicio_execucao: this.state.inicioExecucao
        ? Util.dateOnly(this.state.inicioExecucao)
        : undefined,
      data_assinado: this.state.dataAssinado
        ? Util.dateOnly(this.state.dataAssinado)
        : undefined,
      execucao: this.state.execucao,
      em_execucao: this.state.emExecucao,
      gestor_id: this.state.gestor,
      final_vigencia: this.state.finalVigencia
        ? Util.dateOnly(this.state.finalVigencia)
        : undefined,
      final_execucao: this.state.finalExecucao
        ? Util.dateOnly(this.state.finalExecucao)
        : undefined,
      data_publicacao_extrato: this.state.dataExtrato
        ? Util.dateOnly(this.state.dataExtrato)
        : undefined,
      local_extracao: this.state.localExtracao,
      contrato_id: this.state.contratoOriginal.id,
      observacao: this.state.observacao,
      itens: itens.length === 0 ? undefined : itens,
      itens_realinhamento:
        itensRealinhamento.length === 0 ? undefined : itensRealinhamento
    }
    this.toggleLoadModal()
    if (this.props.isEditing) {
      ApiHelper.updateAditivo(this.props.match.params.id, params, error => {
        this.toggleLoadModal()
        if (error) {
          this.showErrorMessage()
          this.handleErrors(error)
        } else {
          this.showSucessMessage()
          Util.sleep(3000).then(() => {
            this.props.callBackAditivos()
          })
        }
      })
    } else {
      ApiHelper.sendAditivo(params, error => {
        this.toggleLoadModal()
        if (error) {
          this.showErrorMessage()
          this.handleErrors(error)
        } else {
          this.showSucessMessage()
          Util.sleep(3000).then(() => {
            this.props.callBackAditivos()
          })
        }
      })
    }
  }
  handleErrors(errors) {
    var errorsJSON = JSON.parse(errors)
    var errorsValue = errorsJSON.erros
    var errorsState = {}
    var itensError = this.state.itensError
    var itensRealinhamentoError = this.state.itensRealinhamentoError
    for (var key in errorsValue) {
      if (key.includes("itens.")) {
        let index = key.split("itens.").join("")
        if (index.includes(".quantidade")) {
          index = index.split(".quantidade").join("")
          itensError[index].quantidade = errorsValue[key][0]
        }
        if (index.includes(".item_aditivo_id")) {
          index = index.split(".item_aditivo_id").join("")
          itensError[index].item_aditivo_id = errorsValue[key][0]
        }
      } else if (key.includes("itens_realinhamento.")) {
        let index = key.split("itens_realinhamento.").join("")
        if (index.includes(".valor_unitario")) {
          index = index.split(".valor_unitario").join("")
          itensRealinhamentoError[index].valor_unitario = errorsValue[key][0]
        }
        if (index.includes(".item_aditivo_id")) {
          index = index.split(".item_aditivo_id").join("")
          itensRealinhamentoError[index].item_aditivo_id = errorsValue[key][0]
        }
      } else {
        errorsState[key + "Error"] = errorsValue[key][0]
      }
    }
    errorsState.itensError = itensError
    errorsState.itensRealinhamentoError = itensRealinhamentoError
    this.setState(errorsState)
  }
  //Modal de itens de contrato
  toggleItensModal(event, index, itemID) {
    event.preventDefault()
    var editingItem = this.state.currentItens[index]
    if (!editingItem) {
      editingItem = this.state.currentItensRealinhamento[index]
    } else if (editingItem.id !== itemID) {
      editingItem = this.state.currentItensRealinhamento[index]
    }
    this.setState({
      editingItem: editingItem,
      showItemModal: !this.state.showItemModal
    })
  }
  reloadItem(value) {
    var changedItem = value
    changedItem.aditivo = this.state.editingItem.aditivo
    var currentItens = this.state.currentItens
    var currentItensRealinhamento = this.state.currentItensRealinhamento
    var changed = false
    currentItens.forEach((item, index) => {
      if (item.id === changedItem.id) {
        currentItens[index] = changedItem
        changed = true
      }
    })
    if (!changed) {
      currentItensRealinhamento.forEach((item, index) => {
        if (item.id === changedItem.id) {
          currentItensRealinhamento[index] = changedItem
          changed = true
        }
      })
    }
    this.setState({
      currentItens: currentItens,
      currentItensRealinhamento: currentItensRealinhamento,
      showItemModal: false
    })
  }
  removeCurrentItem(event, index, id) {
    event.preventDefault()
    ApiHelper.deleteItemDeContrato(id, error => {
      if (error) {
        this.addAlert("", error.message)
      } else {
        var currentItens = this.state.currentItens
        var currentItensRealinhamento = this.state.currentItensRealinhamento
        if (currentItens[index].id === id) {
          currentItens.splice(index, 1)
        } else {
          currentItensRealinhamento.splice(index, 1)
        }
        this.setState({
          currentItens: currentItens,
          currentItensRealinhamento: currentItensRealinhamento
        })
      }
    })
  }
  render() {
    var execucao = [
      { label: "", value: null },
      { label: "Dia(s)", value: "days" },
      { label: "Mês(es)", value: "months" },
      { label: "Ano(s)", value: "years" }
    ]
    if (this.state.httpError) {
      return (
        <HttpError
          message={this.state.httpError.message}
          status={this.state.httpError.status}
        />
      )
    }
    if (!this.state.showForm) {
      return <Loading />
    } else {
      return (
        <div className="container-fluid">
          <ToastContainer
            ref={input => {
              this.container = input
            }}
            toastMessageFactory={this.toastFactory}
            className="toast-top-right"
            preventDuplicates={true}
          />
          <LoadModalWithLabel
            label="Aguarde..."
            onClose={this.toggleLoadModal}
            show={this.state.showLoad}
          />
          <ItensModal
            editingItem={this.state.editingItem}
            callBack={this.reloadItem}
            show={this.state.showItemModal}
            onClose={this.toggleItensModal}
          />
          <div>
            <div className="card card-plain">
              <div className="card-header" data-background-color="as-blue">
                <h4 className="title">Dados do contrato original</h4>
                <p className="category">
                  Contrato:{this.state.contratoOriginal.objeto}
                </p>
              </div>
              <div className="card-content">
                <div className="row">
                  <InputCustom
                    disabled={true}
                    type="number"
                    sizeClass="col-md-2"
                    label="Número"
                    value={this.state.contratoOriginal.num_contrato}
                  />
                  <InputCustom
                    disabled={true}
                    type="text"
                    sizeClass="col-md-2"
                    label="Número do processo"
                    value={this.state.contratoOriginal.num_processo}
                  />
                  <InputCustom
                    disabled={true}
                    type="text"
                    sizeClass="col-md-5"
                    label="Unidade orçamentária"
                    value={
                      this.state.contratoOriginal.unidade_orcamentaria.uni_orc
                    }
                  />
                </div>
                <div className="row">
                  <InputCustom
                    disabled={true}
                    type="date"
                    sizeClass="col-md-2"
                    label="Data de assinatura"
                    value={this.state.contratoOriginal.data_assinado}
                  />
                  {this.state.contratoOriginal.inicio_execucao && (
                    <div>
                      <InputCustom
                        disabled={true}
                        type="date"
                        sizeClass="col-md-2"
                        label="Data de inicio da execução"
                        value={this.state.contratoOriginal.inicio_execucao}
                      />
                      <InputCustom
                        disabled={true}
                        type="date"
                        sizeClass="col-md-2"
                        label="Data de final da execução"
                        value={this.state.contratoOriginal.final_execucao}
                      />
                    </div>
                  )}
                  <InputCustom
                    disabled={true}
                    type="date"
                    sizeClass="col-md-2"
                    label="Data de final de vigência"
                    value={this.state.contratoOriginal.final_vigencia_inicial}
                  />
                </div>
                <div className="row">
                  <InputCustom
                    disabled={true}
                    type="text"
                    sizeClass="col-md-2"
                    label="Gestor do contrato"
                    value={this.state.contratoOriginal.gestor.name}
                  />
                  <InputCustom
                    disabled={true}
                    type="text"
                    sizeClass="col-md-2"
                    label="Fiscal do contrato"
                    value={this.state.contratoOriginal.fiscal.name}
                  />
                  <InputCustom
                    disabled={true}
                    type="text"
                    sizeClass="col-md-5"
                    label="Contratado"
                    value={
                      this.state.contratoOriginal.contratado
                        ? this.state.contratoOriginal.contratado
                          .nome_razao_social
                        : ""
                    }
                  />
                </div>
                <div className="row">
                  <TextArea
                    disabled={true}
                    sizeClass="col-md-12"
                    label="Objeto"
                    value={this.state.contratoOriginal.objeto}
                  />
                </div>
              </div>
            </div>
            <div className="card card-plain">
              <div className="card-header" data-background-color="as-blue">
                <h4 className="title">Dados do aditivo</h4>
                <p className="category">
                  Alterações nos valores e prazos do contrato original
                </p>
              </div>
              <div className="card-content">
                <div className="row">
                  <InputCustom
                    error={this.state.data_assinadoError}
                    type="date"
                    sizeClass="col-md-2"
                    label="Data de assinatura"
                    onChange={this.onChangeDataAssinado}
                    value={this.state.dataAssinado}
                  />
                  <InputCustom
                    error={this.state.inicio_execucaoError}
                    type="date"
                    sizeClass="col-md-2"
                    label="Data de inicio da execução"
                    value={this.state.inicioExecucao}
                    onChange={this.onChangeInicioExecucao}
                  />
                  <InputCustom
                    error={this.state.execucaoError}
                    sizeClass="col-md-1"
                    label="Execução"
                    type="number"
                    onChange={this.onChangeExecucao}
                    value={this.state.execucao}
                  />
                  <SelectCustom
                    error={this.state.em_execucaoError}
                    sizeClass="col-md-1"
                    options={execucao}
                    label={"Em"}
                    onChange={this.onChangeEmExecucao}
                    value={this.state.emExecucao}
                  />
                  <InputCustom
                    disabled={true}
                    type="date"
                    sizeClass="col-md-2"
                    label="Data de final da execução"
                    value={this.state.finalExecucao}
                  />
                  <InputCustom
                    error={this.state.final_vigenciaError}
                    type="date"
                    sizeClass="col-md-2"
                    label="Data de final de vigência"
                    onChange={this.onChangeFinalVigencia}
                    value={this.state.finalVigencia}
                  />
                </div>
                <div className="row">
                  <InputCustom
                    error={this.state.data_publicacao_extratoError}
                    type="date"
                    sizeClass="col-md-2"
                    label="Data de publicação do extrato"
                    onChange={this.onChangeDataExtrato}
                    value={this.state.dataExtrato}
                  />
                  <InputCustom
                    error={this.state.local_extracaoError}
                    type="text"
                    sizeClass="col-md-2"
                    label={"Local de publicação do extrato"}
                    onChange={this.onChangeLocalExtrato}
                    value={this.state.localExtracao}
                  />
                </div>
                <div className="row">
                  <SelectCustom
                    error={this.state.gestor_idError}
                    sizeClass="col-md-3"
                    options={this.state.gestores}
                    label="Gestor"
                    onChange={this.onChangeGestor}
                    value={this.state.gestor}
                  />
                  {constants.haveRole(1) && (
                    <div>
                      <button
                        onClick={this.toggleGestoresModal}
                        style={{ width: "4%" }}
                        type="button"
                        rel="tooltip"
                        title="Criar gestor"
                        className="btn btn-success btn-simple btn-xs col-md-1"
                      >
                        <i
                          className="icon-header material-icons"
                          style={{ fontSize: 20, top: 18, right: 25 }}
                        >
                          control_point
                        </i>
                      </button>
                    </div>
                  )}
                </div>
                <div className="row">
                  <TextArea
                    error={this.state.objetoError}
                    sizeClass="col-md-12"
                    label="Objeto"
                    onChange={this.onChangeObjeto}
                    value={this.state.objeto}
                  />
                </div>
                <div className="row">
                  <TextArea
                    sizeClass="col-md-12"
                    label="Observação"
                    onChange={this.onChangeObservacao}
                    value={this.state.observacao}
                  />
                </div>
                <div className="card card-plain">
                  <div className="card-header" data-background-color="as-blue">
                    <h4 className="title">Itens do contrato original</h4>
                    <p className="category">
                      Itens que descrevem o contrato original
                    </p>
                  </div>
                  <div className="card-content table-responsive">
                    <table className="table table-hover">
                      <thead>
                        <tr>
                          <th>Descrição do item</th>
                          <th>Valor unitário</th>
                          <th>Quantiade</th>
                          <th>Valor</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.contratoOriginal.itens_de_contratos.map(
                          (item, key) => {
                            return (
                              <tr key={key}>
                                <td>{item.descricao}</td>
                                <td>
                                  {Util.formatCurrency(
                                    parseFloat(item.valor_unitario)
                                  )}
                                </td>
                                <td>{item.quantidade}</td>
                                <td>{Util.formatCurrency(item.valor)}</td>
                              </tr>
                            )
                          }
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
                {
                  this.state.contratoOriginal.tipo_contrato_id !== 0 &&
                  <div className="card card-plain">
                    <div className="card-header" data-background-color="as-blue">
                      <h4 className="title">Alterações de valores</h4>
                      <p className="category">
                        Aumento ou redução nos valores ou quantidade dos itens do
                        contrato
                    </p>
                    </div>
                    <div className="card-content">
                      {this.state.currentItens.map((item, key) => {
                        return (
                          <div key={key} className="row card">
                            <SelectCustom
                              disabled={true}
                              sizeClass="col-md-3"
                              options={this.state.itensDeContrato}
                              label="Item de contrato"
                              value={item.item_aditivo_id}
                            />
                            <InputCustom
                              disabled={true}
                              type="number"
                              step="any"
                              sizeClass="col-md-2"
                              label="Quantidade"
                              value={item.quantidade}
                            />
                            <button
                              title="Remover item"
                              onClick={event =>
                                this.removeCurrentItem(event, key, item.id)
                              }
                              className="btn btn-danger pull-right"
                              data-background-color="red"
                            >
                              <i className="icon-header material-icons">delete</i>
                            </button>
                            <button
                              title="Editar item"
                              onClick={event =>
                                this.toggleItensModal(event, key, item.id)
                              }
                              className="btn btn-danger pull-right"
                              data-background-color="blue"
                            >
                              <i className="icon-header material-icons">create</i>
                            </button>
                          </div>
                        )
                      })}
                      {this.state.itens.map((item, key) => {
                        return (
                          <div key={key} className="row card">
                            <SelectCustom
                              error={this.state.itensError[key].item_aditivo_id}
                              sizeClass="col-md-3"
                              options={this.state.itensDeContrato}
                              label="Item de contrato"
                              onChange={event =>
                                this.onChangeItemAditivo(event, key)
                              }
                              value={item.itemAditivo}
                            />
                            {item.isQuantidade ? (
                              <InputCustom
                                error={this.state.itensError[key].quantidade}
                                sizeClass="col-md-2"
                                label="Quantidade (porcentagem)"
                                onChange={event =>
                                  this.onChangeQuantidadeAditivo(event, key)
                                }
                                value={item.quantidade}
                              />
                            ) : (

                                <InputDinheiroBR
                                  error={this.state.itensError[key].quantidade}
                                  sizeClass="col-md-2"
                                  label="Valor"
                                  onChange={(valueFormatado, value) =>
                                    this.onChangeQuantidadeAditivo(
                                      undefined,
                                      key,
                                      value
                                    )
                                  }
                                  value={item.valor}
                                />
                              )}

                            <InputCustom
                              type="checkbox"
                              sizeClass="col-md-2"
                              checked={item.isQuantidade}
                              label="Aumento na quantidade?"
                              onChange={event =>
                                this.onChangeIsQuantidade(event, key)
                              }
                            />
                            <InputCustom
                              type="checkbox"
                              sizeClass="col-md-2"
                              checked={item.isReducao}
                              label="Reduzir este valor?"
                              onChange={event =>
                                this.onChangeIsReducao(event, key)
                              }
                            />
                          </div>
                        )
                      })}
                      <button
                        onClick={this.removeItem}
                        className="btn btn-danger pull-right"
                        data-background-color="red"
                      >
                        <i className="icon-header material-icons">remove</i>
                      </button>
                      <button
                        onClick={this.addItem}
                        className="btn btn-primary pull-right"
                        data-background-color="green"
                      >
                        <i className="icon-header material-icons">add</i>
                      </button>
                    </div>
                  </div>
                }
                <div className="card card-plain">
                  <div className="card-header" data-background-color="as-blue">
                    <h4 className="title">Realinhamentos</h4>
                    <p className="category">
                      Alterações de preços dos itens de contrato
                    </p>
                  </div>
                  <div className="card-content">
                    {this.state.currentItensRealinhamento.map((item, key) => {
                      return (
                        <div key={key} className="row card">
                          <SelectCustom
                            disabled={true}
                            sizeClass="col-md-3"
                            options={this.state.itensDeContrato}
                            label="Item de contrato"
                            value={item.item_aditivo_id}
                          />
                          <InputCustom
                            disabled={true}
                            sizeClass="col-md-2"
                            label="Novo valor"
                            value={Util.formatCurrency(
                              parseFloat(item.valor_unitario)
                            )}
                          />
                          <button
                            title="Remover item"
                            onClick={event =>
                              this.removeCurrentItem(event, key, item.id)
                            }
                            className="btn btn-danger pull-right"
                            data-background-color="red"
                          >
                            <i className="icon-header material-icons">delete</i>
                          </button>
                          <button
                            title="Editar item"
                            onClick={event =>
                              this.toggleItensModal(event, key, item.id)
                            }
                            className="btn btn-danger pull-right"
                            data-background-color="blue"
                          >
                            <i className="icon-header material-icons">create</i>
                          </button>
                        </div>
                      )
                    })}
                    {this.state.itensRealinhamento.map((item, key) => {
                      return (
                        <div key={key} className="row card">
                          <SelectCustom
                            error={
                              this.state.itensRealinhamentoError[key]
                                .item_aditivo_id
                            }
                            sizeClass="col-md-3"
                            options={this.state.itensDeContrato}
                            label="Item de contrato"
                            onChange={event =>
                              this.onChangeItemAditivoRealinhamento(event, key)
                            }
                            value={item.itemAditivo}
                          />
                          <InputDinheiroBR
                            error={
                              this.state.itensRealinhamentoError[key]
                                .valor_unitario
                            }
                            sizeClass="col-md-2"
                            label="Novo valor"
                            onChange={(valueFormatado, value) =>
                              this.onChangeValorRealinhamento(undefined, key, value)
                            }
                            value={item.valor}
                          />
                        </div>
                      )
                    })}
                    <button
                      onClick={this.removeItemRealinhamento}
                      className="btn btn-danger pull-right"
                      data-background-color="red"
                    >
                      <i className="icon-header material-icons">remove</i>
                    </button>
                    <button
                      onClick={this.addItemRealinhamento}
                      className="btn btn-primary pull-right"
                      data-background-color="green"
                    >
                      <i className="icon-header material-icons">add</i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <button
              onClick={this.sendForm}
              className="btn btn-primary pull-left"
              data-background-color="as-blue"
            >
              Enviar
            </button>
          </div>
        </div>
      )
    }
  }
}
export default withRouter(AditivosForm)



// WEBPACK FOOTER //
// ./src/views/modais/AditivosForm.js